module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_axios@0.15.3@axios/index.js
// module id = 3
// module chunks = 0